<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img
            fluid
            src="@/assets/images/logo/Udara360-logo.png"
            class="logo"
          />
        </b-link>

        <b-card-title class="mb-1">
          Reset Password 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Your new password must be different from previously used passwords
        </b-card-text>

        <!-- form -->
        <b-card>
          <Alert
            :show="showFormError"
            :message="errorMessage"
          />
          <!-- form -->
          <validation-observer ref="changePasswordForm">
            <b-form>
              <b-row>
                <!-- new password -->
                <b-col md="12">
                  <InputPasswordField
                    id="new-password"
                    v-model="userDetails.newPassword"
                    label="New Password"
                    placeholder="New Password"
                    error-name="new password"
                    rules="required|min:6|upperCaseChar|lowerCaseChar|numberVal|specialChar"
                    vid="newPassword"
                  />
                </b-col>
                <!--/ new password -->

                <!-- retype password -->
                <b-col md="12">
                  <InputPasswordField
                    id="retype-password"
                    v-model="userDetails.confirmNewPassword"
                    label="Retype Password"
                    placeholder="Retype Password"
                    error-name="retype password"
                    rules="required|confirmed:newPassword"
                  />
                </b-col>
              </b-row>
              <!--/ retype password -->

              <!-- submit button -->
              <b-row class="m-1">
                <Button
                  label="Save"
                  size="lg"
                  block
                  :loading="isLoading"
                  :disabled="isDisabled"
                  @click="changeUserPassword"
                />
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  class="ml-1"
                >
                  Cancel
                </b-button>
                <!--/ buttons -->
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>

        <p class="text-center mt-2">
          <b-link :to="{name:'auth-login'}">
            <feather-icon icon="ChevronLeftIcon" /> Back to login
          </b-link>
        </p>

      </b-card>
    <!-- /Reset Password v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BRow, BCol, BCard, BImg, BLink, BCardText, BCardTitle,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { mapActions } from 'vuex'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'
import InputPasswordField from '../../forms/InputPasswordField.vue'

export default {
  components: {
    BImg,
    BLink,
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    InputPasswordField,
    ValidationObserver,
    Button,
    Alert,
  },
  directives: {
    Ripple,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      userDetails: {
        newPassword: '',
        confirmNewPassword: '',
      },
      email: '',
      oldPassword: '',
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: '',
      required,
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    ...mapActions({
      changePasswordExpiration: 'auth/changePasswordExpiration',
    }),
    getUser() {
      const { user } = this.$route.params
      if (user) {
        this.email = user.username
        this.oldPassword = user.password
      } else {
        this.$router.push({ name: 'auth-forgot-password' })
      }
    },
    changeUserPassword() {
      this.$refs.changePasswordForm.validate().then(async success => {
        if (success) {
          try {
            this.showFormError = false
            this.isDisabled = true
            this.isLoading = true
            await this.changePasswordExpiration({
              ...this.userDetails,
              email: this.email,
              oldPassword: this.oldPassword,
            })
              .then(() => {
                this.$router
                  .push({ name: 'auth-login' })
                this.toastAlert({
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'You have successfully changed your password',
                })
              })
            this.isDisabled = false
            this.isLoading = false

            return true
          } catch (error) {
            this.showFormError = true
            error.response.data.errors.forEach(responseError => {
              this.errorMessage = responseError.errorMessage
            })
          } finally {
            this.isDisabled = false
            this.isLoading = false
          }
        }
        return false
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
